/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { getGenreParam } from '../../utils/getSearchParam';
import {
  H1, FlexBox, ClickableBox, SpacingBox,
} from '../../Components';
import {
  navigateToProductListWithClusterAndGenre,
  navigateToProductListWithClusters,
} from '../../utils/navigations';
import { existsAndNotEmptyString } from '../../utils/strings';
import { getTranslateByScope } from '../../i18n';
import styles from './style.module.scss';

const clustersTranslations = getTranslateByScope('clusters');

export const ProductTitle = (props) => (
  <FlexBox justifyContent="center" marginVertical="lg">
    <H1>{props.description}</H1>
  </FlexBox>
);

export const ProductTitleForClusters = withRouter((props) => {
  const genre = getGenreParam(props.location);
  const clusters = _.uniq(
    props.clusters.split('|').map(_.trim).filter(existsAndNotEmptyString),
  );

  // Works like a breadcrumb: go to every part up to and including the clicked one
  const onClick = (index) => {
    const { history } = props;
    const selectedClusters = clusters.slice(0, index + 1).join(' | ');
    if (genre) {
      navigateToProductListWithClusterAndGenre({
        history,
        genre,
        clusters: selectedClusters,
      });
    } else {
      navigateToProductListWithClusters({ history, clusters: selectedClusters });
    }
  };

  return (
    <FlexBox
      className={styles.clustersTitle}
      justifyContent="center"
      alignItems="center"
      flexWrap="wrap"
      marginVertical="xxl">
      {clusters.map((part, index) => (
        <React.Fragment key={part}>
          {index > 0 && (
            <SpacingBox marginLeft="md" marginRight="md">
              <H1 className={styles.titleSeparator}>|</H1>
            </SpacingBox>
          )}
          <ClickableBox
            className={styles.titlePart}
            onClick={() => onClick(index)}>
            <H1>{clustersTranslations(part)}</H1>
          </ClickableBox>
        </React.Fragment>
      ))}
    </FlexBox>
  );
});
